/**
 * EmptyState — Centred placeholder for empty lists or no-data conditions.
 *
 * Props:
 *   icon         ReactNode   — SVG or emoji icon shown above title
 *   title        string      — primary message
 *   description  string      — secondary message (optional)
 *   action       ReactNode   — CTA button or link (optional)
 */
export default function EmptyState({ icon, title, description, action }) {
  return (
    <div className="empty-state">
      {icon && <div className="empty-state-icon">{icon}</div>}
      <h3 className="empty-state-title">{title}</h3>
      {description && <p className="empty-state-desc">{description}</p>}
      {action && <div className="empty-state-action">{action}</div>}
    </div>
  )
}
